module.exports = __webpack_public_path__ + "static/media/team-inbox.d3a1747b.svg";